// Registers public/sw.js at the site root so it controls the whole origin —
// app-shell caching plus the push/notificationclick listeners. Runs after
// window 'load' so it never competes with the initial page render.
export function registerServiceWorker() {
  if (!("serviceWorker" in navigator)) return;

  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/sw.js")
      .catch((error) => {
        console.error("[ServiceWorker] Registration failed:", error);
      });
  });
}
